export const trackingNotificationType = {
  system: 'S',
  priceChange: 'PC',
  volumeChange: 'VC',
  newsUpdate: 'NU',
  companyExercise: 'CE',
  PackagePayment: 'PP',
  PackageNotPayment: 'PNP',
  Synthetic: 'SYN',
  Indicator: 'IND',
  Investment: 'INV',
  GENERAL: 'GEN',
  GENERAL_FOLLOW: 'GENF',
  Notification: 'Noti',
  Warning: 'warn',
};

export const notificationStatusType = {
  New: 0,
  Sent: 1,
  Failed: 2,
  Read: 3,
  Archived: 4,
  View: 5,
};
export const notificationTabs = {
  Investment: 0,
  Follow: 1,
  Other: 2,
};

export const DEFAULT_LOGO = '/images/a369/logo.svg';
export const SPECIAL_EXCHANGE = [
  'vn-index',
  'hnx-index',
  'upcom-index',
  'vn30-index',
  'hnx30-index',
];
